import { render, staticRenderFns } from "./rosterprofileView.vue?vue&type=template&id=087cab9a"
import script from "./rosterprofileView.vue?vue&type=script&lang=js"
export * from "./rosterprofileView.vue?vue&type=script&lang=js"
import style0 from "./rosterprofileView.vue?vue&type=style&index=0&id=087cab9a&prod&lang=css"
import style1 from "./rosterprofileView.vue?vue&type=style&index=1&id=087cab9a&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports